<template lang="html">
  <div class="order-info-list">
    <div class="item-cells">
      <div class="item-cell">
        <div class="item-cell-hd">订单编号：</div>
        <div class="item-cell-bd">
          <span id="success_form_input">{{ order.orderId }}</span
          ><button
            @click="copyOrderId"
            ref="copy"
            :data-clipboard-text="order.orderId"
            data-clipboard-target="#success_form_input"
            class="copyText"
          >
            复制
          </button>
        </div>
        <!-- <div class="item-cell-ft refund-detail" v-if="order.refundState === 20 && order.payType == 2">
                    <router-link :to="`/order/payment/${order.orderId}?cmd=share&sharetype=0&refresh=no&type=2`">
                        <span>查看退款凭证</span><i class="iconfont icon-youjiantou"></i>
                    </router-link>
                </div> -->
      </div>
      <div class="item-cell">
        <div class="item-cell-hd">下单时间：</div>
        <div class="item-cell-bd">
          {{ $$dateFormat(order.orderCreateTime, 'YY.MM.DD hh:mm:ss') }}
        </div>
      </div>
      <div class="item-cell">
        <div class="item-cell-hd">订单状态：</div>
        <div class="item-cell-bd">
          {{ stateDesc }}
        </div>
        <!-- <div class="item-cell-ft refund-detail" v-if="order.orderState===20 && order.refundState !== 10">
                    <router-link :to="`/order/${order.orderId}/refund`">
                        <span>退款详情</span><i class="iconfont icon-youjiantou"></i>
                    </router-link>
                </div> -->
      </div>
      <div class="item-cell" v-if="remark">
        <div class="item-cell-hd">备注:</div>
        <div class="item-cell-bd">
          <div class="remark">
            <p>{{ remark ? remark : '无' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      default() {
        return {}
      }
    },
    stateDesc: {
      type: String,
      default: ''
    },
    state: {
      type: Number,
      default: -1
    },
    remark: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {
    this.copyBtn = new this.$$clipboard(this.$refs.copy)
  },
  methods: {
    copyOrderId() {
      let _this = this
      let clipboard = _this.copyBtn
      clipboard.on('success', function (e) {
        _this.$$toast('复制成功')
        return
      })
      clipboard.on('error', function (e) {
        window.prompt('复制失败，请手动复制', e.text)
      })
    }
  },
  filters: {},
  computed: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.order-info-list {
  margin: rem(20px) rem(24px) rem(20px);
  border-radius: rem(16px);
  background: #fff;

  .copyText {
    font-size: rem(26px);
    color: #ff5900;
    line-height: rem(32px);
    margin-left: rem(19px);
  }

  .item-cells {
    padding: rem(44px) 0 rem(20px);
    border-radius: rem(16px);
  }
  .item-cell {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 0;
    font-size: rem(26px);
    color: #262626;
    line-height: rem(32px);

    .item-cell-hd {
      font-size: rem(26px);
      color: #262626;
      line-height: rem(32px);
    }

    .item-cell-bd {
      font-weight: 500;
      font-size: rem(26px);
      color: #121212;
      line-height: rem(32px);
      text-align: right;
    }
  }
}
.price-total {
  margin-top: rem(21px);

  .item-cell-bd {
    text-align: right;
  }
  .actual-pay {
    .item-cell-bd {
      color: #ff5900;
    }
  }
}
.refund-detail {
  .iconfont {
    vertical-align: middle;
  }
}

.remark {
  word-wrap: break-word;
  word-break: break-word;
  display: flex;
  justify-content: flex-end;
  p {
    max-width: rem(526px);
  }
}
</style>
